module.exports = __webpack_public_path__ + "img/buy_now.a93e11af.png";